const SIN_NOMBRE = "(sin nombre)";

//el metadato CLIIDXXX llega como string, arreglo de strings o arreglo de objetos segun como
//lo haya guardado Autocomx, por eso se normaliza antes de consultar
const extractClientId = (item) => {
  if (item === null || item === undefined) return "";
  if (typeof item !== "object") return String(item).trim();
  if (item.id !== null && item.id !== undefined) return String(item.id).trim();
  if (item.CLIIDXXX !== null && item.CLIIDXXX !== undefined) return String(item.CLIIDXXX).trim();
  if (typeof item.label === "string") {
    //Autocomx arma el label como "NOMBRE - NIT"
    const partes = item.label.split(" - ");
    return partes[partes.length - 1].trim();
  }
  return "";
};

export const normalizeClientIds = (value) => {
  if (value === null || value === undefined || value === "") return [];
  const crudos = Array.isArray(value) ? value : [value];
  return [...new Set(crudos.map(extractClientId).filter(id => id !== ""))];
};

//se recorren los ids pedidos y no la respuesta, para que la lista siempre cuadre
//con lo que muestra el campo CLIENTE aunque la api no devuelva alguno
export const buildClientNameLines = (ids, clients = []) => {
  const nombresPorId = {};
  clients.forEach((client) => {
    if (client && client.CLIIDXXX !== null && client.CLIIDXXX !== undefined) {
      nombresPorId[String(client.CLIIDXXX).trim()] = client.CLINOMXX;
    }
  });
  return ids.map(id => `${id} - ${nombresPorId[id] ? nombresPorId[id] : SIN_NOMBRE}`);
};
